/* LaFarmacia - Newsletter sin recargar la pagina (Clau 16 oct 2026)
   "cuando me suscribo a la newsletter se vuelve a cargar la pagina y eso no
   debe ser, debe aparecer de inmediato el mensaje gracias por suscribirte
   (destacar el mensaje ya que se pierde)".

   Se carga desde sections/footer.liquid (todas las paginas), con defer.
   Afecta solo a los formularios de newsletter de Shopify: el del pie
   (#ContactFooter) y el de la seccion "Newsletter" de Dawn (.newsletter).

   - Al pulsar suscribirse NO se recarga la pagina: en el mismo instante se
     cambia la casilla del email por un mensaje verde bien visible
     "¡Gracias por suscribirte!".
   - El alta se hace igual que antes: se envia el MISMO formulario a /contact
     (cliente de Shopify con la etiqueta "newsletter"), pero en segundo plano.
     Ademas se avisa a Connectif (igual que el boton "Avisame" de la ficha).
   - Si Shopify devuelve un error (email no valido...) se vuelve a mostrar el
     formulario con el error en rojo.
   - Si Shopify pide la verificacion anti-robots (/challenge) o algo falla en
     la red, se envia el formulario de la forma de siempre (recarga), para que
     nunca se pierda una suscripcion.
   - Si la pagina se recarga de todas formas (?customer_posted=true), el
     mensaje de Shopify tambien sale destacado (mismo estilo). */
(function(){
  if(window.__lafNewsletter) return; window.__lafNewsletter = true;

  var CSS = ''
    + '@keyframes laf-nl-pop{0%{opacity:0;transform:scale(.9)}60%{opacity:1;transform:scale(1.04)}100%{transform:scale(1)}}'
    + '.laf-nl-ok,.newsletter-form__message--success{display:flex!important;align-items:center;gap:12px;box-sizing:border-box;width:100%;'
    +   'margin:12px 0 0!important;padding:14px 16px!important;background:#e9f7ef!important;border:2px solid #1f9d55!important;border-radius:12px;'
    +   'color:#145c33!important;font-size:17px!important;font-weight:700!important;line-height:1.3!important;text-align:left;'
    +   'box-shadow:0 6px 18px rgba(31,157,85,.25);animation:laf-nl-pop .45s ease-out both}'
    + '.laf-nl-ok:focus{outline:none}'
    + '.laf-nl-ok__ico{flex:0 0 34px;width:34px;height:34px;border-radius:50%;background:#1f9d55;color:#fff;display:flex;align-items:center;justify-content:center}'
    + '.laf-nl-ok__txt small{display:block;margin-top:2px;font-size:13px;font-weight:500;color:#2c6e48}'
    + '.newsletter-form__message--success .svg-wrapper,.newsletter-form__message--success .icon{color:#1f9d55}'
    + '.laf-nl-err{display:block;margin-top:8px;padding:8px 12px;border-radius:8px;background:#fdecec;border:1px solid #e8352e;color:#b3261e;font-size:14px;font-weight:600}'
    + 'form.laf-nl-enviado .newsletter-form__field-wrapper,form.laf-nl-enviado .newsletter-form__button,form.laf-nl-enviado > .field{display:none!important}';

  function ponerEstilo(){
    if(document.getElementById('laf-nl-css')) return;
    var st = document.createElement('style'); st.id = 'laf-nl-css'; st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }

  var ICONO = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function esNewsletter(form){
    if(!form || form.tagName !== 'FORM') return false;
    if(!(form.id === 'ContactFooter' || (form.classList.contains('newsletter-form') && form.closest('.newsletter')))) return false;
    var ft = form.querySelector('input[name="form_type"]');
    var tags = form.querySelector('input[name="contact[tags]"]');
    return !!(ft && ft.value === 'customer' && tags && /newsletter/.test(tags.value) && form.querySelector('input[name="contact[email]"]'));
  }

  function quitarMensajes(form){
    form.querySelectorAll('.laf-nl-ok, .laf-nl-err').forEach(function(n){ n.remove(); });
  }

  function mostrarGracias(form){
    quitarMensajes(form);
    // Mensaje de una recarga anterior: se quita para no duplicar
    form.querySelectorAll('.newsletter-form__message').forEach(function(n){ n.remove(); });
    var ok = document.createElement('div');
    ok.className = 'laf-nl-ok';
    ok.setAttribute('role', 'status');
    ok.setAttribute('aria-live', 'polite');
    ok.setAttribute('tabindex', '-1');
    ok.innerHTML = '<span class="laf-nl-ok__ico">' + ICONO + '</span>'
      + '<span class="laf-nl-ok__txt">¡Gracias por suscribirte!<small>Te mantendremos al día de nuestras ofertas y novedades.</small></span>';
    form.appendChild(ok);
    form.classList.add('laf-nl-enviado');
    try { ok.focus({ preventScroll: true }); } catch(e){}
    var r = ok.getBoundingClientRect();
    if(r.bottom > window.innerHeight || r.top < 0){ ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }

  function mostrarError(form, texto){
    quitarMensajes(form);
    form.classList.remove('laf-nl-enviado');
    var er = document.createElement('small');
    er.className = 'laf-nl-err';
    er.setAttribute('role', 'alert');
    er.textContent = texto || 'No se ha podido completar la suscripción. Revisa el email e inténtalo de nuevo.';
    var wrap = form.querySelector('.newsletter-form__field-wrapper') || form;
    wrap.appendChild(er);
    var input = form.querySelector('input[name="contact[email]"]');
    if(input){ input.setAttribute('aria-invalid', 'true'); input.focus(); }
  }

  /* Igual que el "Avisame" de la ficha (laf-extras.js): evento de alta en la
     newsletter de Connectif, si su script (app embed) esta cargado. */
  function avisarConnectif(email){
    function listo(){ return window.connectif && window.connectif.managed && typeof window.connectif.managed.sendEvents === 'function' && (typeof window.connectif.managed.isInitialized !== 'function' || window.connectif.managed.isInitialized()); }
    function enviar(){
      try {
        window.connectif.managed.sendEvents(
          [{ type: 'newsletter-subscribe', email: email }],
          { entityInfo: { primaryKey: email, _newsletterSubscriptionStatus: 'subscribed' } }
        );
      } catch(e){ console.warn('[LaF newsletter] Connectif:', e && e.message); }
    }
    if(listo()){ enviar(); return; }
    var n = 0, t = setInterval(function(){
      n++;
      if(listo()){ clearInterval(t); enviar(); }
      else if(n > 30){ clearInterval(t); console.warn('[LaF newsletter] script de Connectif no disponible'); }
    }, 200);
  }

  /* Envio de siempre (con recarga). Se usa solo si el envio en segundo plano
     no se puede completar, para no perder la suscripcion. */
  function envioNormal(form){
    form.__lafNlNormal = true;
    HTMLFormElement.prototype.submit.call(form);
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!esNewsletter(form) || form.__lafNlNormal) return;
    if(!window.fetch || !window.FormData || !window.DOMParser) return; // navegador muy antiguo: como siempre
    e.preventDefault();
    if(form.__lafNlEnviando) return;
    form.__lafNlEnviando = true;

    var datos = new FormData(form);
    var email = String(datos.get('contact[email]') || '').trim();
    var accion = form.getAttribute('action') || '/contact';

    ponerEstilo();
    mostrarGracias(form);                 // de inmediato
    if(email){ avisarConnectif(email); }

    fetch(accion, { method: 'POST', body: new URLSearchParams(datos), credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function(r){
        var url = r.url || '';
        if(url.indexOf('/challenge') >= 0){ throw { normal: true }; }
        if(url.indexOf('customer_posted=true') >= 0){ return null; }   // alta correcta
        if(!r.ok){ throw { normal: true }; }
        return r.text().then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          if(doc.querySelector('#ContactFooter-success, .newsletter-form__message--success')){ return null; }
          var err = doc.querySelector('#ContactFooter-error, .newsletter-form__message:not(.newsletter-form__message--success), .form__message[id*="error"]');
          if(err){ return (err.textContent || '').replace(/\s+/g, ' ').trim(); }
          return null;                                                  // sin error: se da por buena
        });
      })
      .then(function(error){
        form.__lafNlEnviando = false;
        if(error){ mostrarError(form, error); }
        else {
          var input = form.querySelector('input[name="contact[email]"]');
          if(input){ input.value = ''; input.removeAttribute('aria-invalid'); }
        }
      })
      .catch(function(){
        form.__lafNlEnviando = false;
        envioNormal(form);
      });
  }, true);

  // Si la pagina viene de una recarga con el mensaje de Shopify, se destaca igual
  function destacarServidor(){
    if(document.querySelector('.newsletter-form__message--success')){ ponerEstilo(); }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', destacarServidor); } else { destacarServidor(); }
})();
